import React from 'react'
import { Route } from 'react-router-dom'
import { Grid, Header, Message } from 'semantic-ui-react'
import { AuthContext } from '@dexter-experts/auth-react'
import Logobar from '../Logobar'

const PublicProjectRoute = ({ path, component: Component }) => {
  const { authUser } = React.useContext(AuthContext)

  return (
    <>
      <Logobar />
      <Route path={path}>
        <div id="public-project-landing">
          <Grid stackable>
            <Grid.Row>
              <Grid.Column computer={2} only={'computer'} />
              <Grid.Column computer={10}>
                {authUser?.email && (
                  <Message info size="small">
                    This invitation was sent to{' '}
                    <strong>{authUser.email}</strong>
                  </Message>
                )}
                <Component />
              </Grid.Column>
              <Grid.Column computer={4}>
                <div id="contact">
                  <Header sub>Questions?</Header>
                  <span id="contact-text">
                    Contact help@dexterexperts.com <br />
                    for any questions
                  </span>
                </div>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Route>
    </>
  )
}

export default PublicProjectRoute
